import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './SubscriptionPlan.module.css';

const SubscriptionPlanDetails = ({ planList, membershipList, handleScrollToPlans }) => {
  return (
    <>
      {/* ─── Green Section: One Flexible Monthly Plan That Grows With Your Kids ─── */}
      <div className={css.kidsPlanWrapper}>
        <div className={css.kidsPlanContainer}>
          <div className={css.planGrid}>
            <div className={css.planLeft}>
              <h2 className={css.planMainHeading}>
                <FormattedMessage id="SubscriptionPlan.section.planHeading" />
              </h2>
              <p className={css.planMainSubHeading}>
                <FormattedMessage id="SubscriptionPlan.section.planSubHeading" />
              </p>
            </div>
            <div className={css.planRight}>
              <div className={css.planFeatureCardsList}>
                {planList.map((item, i) => (
                  <div key={i} className={css.featureCard}>
                    <div className={css.featureIconCircle} aria-hidden="true">
                      {item.icon}
                    </div>
                    <div className={css.featureCardContent}>
                      <h3 className={css.featureCardHeading}>{item.heading}</h3>
                      <p className={css.featureCardSubHeading}>{item.subHeading}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── Gold Section: How Your Arabibi Membership Works ─── */}
      <div className={css.membershipWrapper}>
        <div className={css.membershipContainer}>
          <div className={css.membershipHeader}>
            <h2 className={css.membershipHeading}>
              <FormattedMessage id="SubscriptionPlan.membership.heading" />
            </h2>
            <p className={css.membershipSubHeading}>
              <FormattedMessage id="SubscriptionPlan.membership.subHeading" />
            </p>
          </div>

          <div className={css.membershipGrid}>
            {membershipList.map((item, i) => (
              <div key={`membership-item-${i}`} className={css.membershipCard}>
                <div
                  className={css.countingCircle}
                  style={{ backgroundColor: item.countColor }}
                  aria-hidden="true"
                >
                  {i + 1}
                </div>
                <div className={css.membershipCardBody}>
                  <h3 className={css.membershipItemHeading}>{item.heading}</h3>
                  <p className={css.membershipItemSubHeading}>{item.subHeading}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={css.choosePlanWrapper}>
            <button type="button" className={css.choosePlanButton} onClick={handleScrollToPlans}>
              <FormattedMessage id="SubscriptionPlan.membership.choosePlanButton" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlanDetails;
